module.exports = __webpack_public_path__ + "static/media/ts7cr93.7a3dceaa.png";